import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { generateInitialValues } from '../../common/FormkControls/formSchemaGenerator';
import { FORM_NAMES } from '../../../actions/formNames';
import { cookieGetExpires, cookieGetUserId } from '../../../reducers/cookies';
import { apiSupportRequest } from '../../../actions/Api/Support/apiSupportRequest';
import ReactiveForm from '../../common/ReactiveForm';
import * as Yup from 'yup';
import { basicColumnDef } from '../../common/FilteredTable/tableAndFilterHelpers';

const FORM_NAME = FORM_NAMES.SUPPORT;
const formDef = {
    sections: [
        {
            title: 'Contact Details',
            order: 0,
            fields: [
                {
                    fieldName: 'userId',
                    defaultValue: -1
                },
                {
                    fieldName: 'tokenExpires',
                    defaultValue: -1
                },
                {
                    fieldName: 'roles',
                    defaultValue: []
                },
                {
                    fieldName: 'errors',
                    defaultValue: []
                },
                {
                    fieldName: 'system',
                    defaultValue: []
                },
                {
                    order: 1,
                    fieldName: 'email',
                    title: 'Email',
                    schema: {
                        type: 'email',
                        required: 'Email is required',
                        invalidEmail: 'Invalid email address'
                    }
                },
                {
                    order: 2,
                    fieldName: 'phoneNumber',
                    title: 'Phone'
                }
            ]
        },
        {
            title: 'Describe the problem',
            order: 1,
            fields: [
                {
                    order: 1,
                    fieldName: 'issue',
                    title: 'issue',
                    schema: {
                        type: 'string',
                        required: 'Please select a value'
                    }
                },
                {
                    order: 1,
                    fieldName: 'notes',
                    title: 'Notes',
                    type: 'textarea',
                    schema: {
                        type: 'string',
                        required: 'Please provide as many details as possible'
                    }
                },
                {
                    order: 1,
                    fieldName: 'contactTime',
                    title: 'Best time to contact',
                    type: 'textarea',
                    schema: {
                        type: 'string'
                    }
                }
            ]
        }
    ]
};

class SupportForm extends React.Component {
    handleSubmit = values => this.props.save(values, this.props.cancel);

    render() {
        const { user, cancel, resources } = this.props;
        const formDefinition = _.cloneDeep(formDef);

        let initialValues = {
            ...generateInitialValues(formDefinition),
            userId: cookieGetUserId(),
            tokenExpires: cookieGetExpires(),
            email: user.email,
            roles: user.roles,
            phoneNumber: user.mobile,
            errors: user.errors, //TODO: convert errors to an array of strings
            system: "BMW ENGAGGE"
        };

        return (
            <ReactiveForm
                initialValues={initialValues}
                resources={resources}
                onCancel={cancel}
                formName={FORM_NAME}
                validationSchema={Yup.object().shape({
                    issue: Yup.string().required('Please select a value.'),
                    notes: Yup.string().required('Please provide as many details as possible.'),
                    email: Yup.string()
                        .required('Email is required')
                        .email('Invalid email address')
                })}
                handleSubmit={this.handleSubmit}
            >
                <ReactiveForm.Section title="Contact Details">
                    <ReactiveForm.Text columnDef={{ ...basicColumnDef('EMAIL', 'email'), type: 'email' }} />
                    <ReactiveForm.Text columnDef={basicColumnDef('Phone', 'phoneNumber')} />
                </ReactiveForm.Section>

                <ReactiveForm.Section title="Describe the problem">
                    <ReactiveForm.Text columnDef={basicColumnDef('Issue', 'issue')} />
                    <ReactiveForm.Text columnDef={{ ...basicColumnDef('Notes', 'notes'), type: 'textarea' }} />
                    <ReactiveForm.Text
                        columnDef={{ ...basicColumnDef('Best time to contact', 'contactTime'), type: 'textarea' }}
                    />
                </ReactiveForm.Section>
            </ReactiveForm>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    errors: state.errors,
    resources: state.resources
});

const mapDispatchToProps = dispatch => ({
    save: (form, cancel) => {
        dispatch(apiSupportRequest(form));
        cancel();
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SupportForm);
